var render = function render(_c,_vm){return _c('div',{staticClass:"facts"},[(_vm.props.header)?_c('h2',[_vm._v(" "+_vm._s(_vm.props.header)+" ")]):_vm._e(),_c('div',{staticClass:"text-center smaller text-condensed text-uppercase font-weight-bold flex-wrap"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }